import React, { Component } from 'react';
import { connect } from 'react-redux';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import { PortalModal } from '~/components/views/common/styled/Modal/Modal';
import { BodyContent } from '~/components/views/common/styled/Modal/styled';
import { closeInfoModal } from './actions';

export interface Props {
  langKey: string;
  langKeyHeader: string;
  closeButtonLangKey: string;
  closeInfoModal: typeof closeInfoModal;
  onAfterClose?(): void;
}

export class InfoModalContainer extends Component<Props> {
  closeModal = () => {
    this.props.closeInfoModal();

    if (this.props.onAfterClose) {
      this.props.onAfterClose();
    }
  };

  render() {
    const { langKeyHeader, langKey, closeButtonLangKey } = this.props;
    return (
      <PortalModal
        isOpen={true}
        onClose={this.closeModal}
        title={{ key: langKeyHeader }}
        actionButtons={[
          {
            label: { key: closeButtonLangKey },
            onClick: this.closeModal,
            variant: 'primary',
            size: 'small',
            type: 'button',
            key: 'infoModalClose',
          },
        ]}
        infoOrErrorOrWarning={true}
        testId="infoModal"
        id="infoModal"
      >
        <BodyContent>
          {formatMessageWrapper(langKey)
            .split('\n')
            .map((str) => (
              <div key={str}>{str}&nbsp;</div>
            ))}
        </BodyContent>
      </PortalModal>
    );
  }
}

const mapDispatchToProps = {
  closeInfoModal,
};

const mapStateToProps = ({ infoModal }) => {
  const { langKey, langKeyHeader, closeButtonLangKey, onAfterClose } = infoModal;
  return { langKey, langKeyHeader, closeButtonLangKey, onAfterClose };
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoModalContainer);
